import { capitalize } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'

class MultiQuestion {
    id = uuidv4()

    kind = 'MultiQuestionSlide'

    @observable childPageQuestionId

    @observable comparisonSurveyIds

    @observable benchmarks

    @observable

    removeBaseLimit

    display

    comment

    parentDataRanking

    ranking

    template = 'CHART_2x2'

    @observable multiQuestion = [
        {
            id: uuidv4(),
            index: 1,
        },
        {
            id: uuidv4(),
            index: 2,
        },
        {
            id: uuidv4(),
            index: 3,
        },
        {
            id: uuidv4(),
            index: 4,
        },
    ]

    constructor({ comparisonSurveyIds, benchmarks, questionTypeCode }) {
        this.multiQuestion = this.multiQuestion.map((question) => ({
            ...question,
            benchmarks: benchmarks.map((b) => ({
                ...b,
                value: `${question.id}_${b.value}`,
            })),
            comparisonSurveyIds: comparisonSurveyIds.map((b) => ({
                ...b,
                value: `${question.id}_${b.value}`,
            })),
        }))

        switch (questionTypeCode) {
            case 'MultiQuestion1x2':
                this.multiQuestion = this.multiQuestion.splice(0, 2)
                this.template = 'CHART_1x2'
                break
            case 'MultiQuestion1x3':
                this.multiQuestion = this.multiQuestion.splice(0, 3)
                this.template = 'CHART_1x3'
                break
            default:
                break
        }
    }

    multiQuestiontoJSON = () => (
        this.multiQuestion.map((question) => ({
            id: question.id,
            pageQuestionId: question.pageQuestionId,
            chartType: question.chartType,
            ranking: question.ranking,
            showAverage: Boolean(question.showAverage),
            benchmarks: (question.benchmarks ?? []).filter(({ checked }) => checked).map(({ value }) => value.split('_')[1]),
            comparisonSurveyIds: (question.comparisonSurveyIds ?? []).filter(({ checked }) => checked).map(({ value }) => value.split('_')[1]),
            coding: question.coding,
            index: question.index,
        })).filter(({ pageQuestionId }) => !!pageQuestionId)
    )

    toJSON() {
        const comparisonSurveyIds = Array.from(new Set(
            this.multiQuestion.map(({ comparisonSurveyIds }) => (
                (comparisonSurveyIds ?? []).filter(({ checked }) => checked).map(({ value }) => value.split('_')[1])
            )).flat(),
        ))

        console.log('toJSON', comparisonSurveyIds)

        return {
            kind: this.kind,
            chartType: '',
            ranking: 'highToLow',
            pageQuestionId: '',
            template: this.template,
            comparisonSurveyIds,
            multiQuestion: this.multiQuestiontoJSON(),
        }
    }
}

export default MultiQuestion
